import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  margin-top: 2rem;
  flex: 1;
  flex-direction: column;
  height: 100%;
`;

export const CodeAuth = styled.iframe`
  width: 100%;
  height: 100%;
  border: 0;
`;
